export default __webpack_public_path__ + "static/AceHandyMan-811e02fdab5323520adfc3b2c29741a9.png";